export default {
  MuiTab: {
    root: {
      textTransform: 'none',
      fontSize: 16,
      fontWeight: 700,
      minWidth: 'inherit',
      padding: 0,
      minHeight: 'unset',
      marginBottom: 10,
    },
  },
  MuiTabs: {
    root: {
      minHeight: 'unset',
    },
  },
  PrivateTabIndicator: {
    root: {
      height: 4,
    },
    colorPrimary: {
      backgroundColor: '#26A69A',
    },
  },
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/overrides/Tabs.js